import { Navigate } from "react-router-dom"
import LoadingSpinTrail from "../components/loading/LoadingSpinTrail"
import { useSelectedCompany } from "../context/companyProvider"
import { usePublicSiteId } from "../contexts/PublicSiteContext"
import { isConstructionWalk } from "../utils/publicSite"

/**
 * ConstructionWalk job sites / employees require a selected company.
 * Admins with none selected are sent to Companies. Non-admins wait for login bind.
 */
export default function CompanyScopedRoute({ children }: { children: JSX.Element }) {
  const siteId = usePublicSiteId()
  const { hasSelectedCompany, isAdmin, isReady } = useSelectedCompany()

  if (!isConstructionWalk(siteId)) {
    return children
  }

  if (!isReady) {
    return <LoadingSpinTrail />
  }

  if (!hasSelectedCompany) {
    return isAdmin ? <Navigate to="/app/management-companies" replace /> : <Navigate to="/app" replace />
  }

  return children
}
